import { render, staticRenderFns } from "./OpeningHoursForm.vue?vue&type=template&id=1a92cdf4&"
import script from "./OpeningHoursForm.vue?vue&type=script&lang=js&"
export * from "./OpeningHoursForm.vue?vue&type=script&lang=js&"
import style0 from "./OpeningHoursForm.vue?vue&type=style&index=0&id=1a92cdf4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports